/**
 * @format
 */

import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { toggleBackoffice } from 'state/slice/tabSlice';
import { toggleForm } from 'state/slice/buttonSlice';
import { FilterType } from '../types/users.types';
import { useOfficeUsers } from '../hooks/useUsers';
import UsersTable from '../components/UsersTable';
import OfficeNames from 'components/officeNames';
import { Select, Input } from 'antd';
import DownArrow from 'img/ArrowLineDown.png';
import Filter from 'img/ArrowsDownUp.svg';

const { Option } = Select;
const { Search } = Input;

/**
 * Container component for Users Table
 * Handles data fetching, filtering, and search
 */
const UsersTableContainer: React.FC = () => {
  const dispatch = useDispatch();
  const [filterBy, setFilterBy] = useState<FilterType>('Office');
  const [searchQuery, setSearchQuery] = useState('');

  const selectedOfficeId = useSelector(
    (state: RootState) => (state.dropDown as any).officeId
  );

  // Fetch users by office using GraphQL
  const { users: filteredUsers, loading: filterLoading } = useOfficeUsers(
    filterBy === 'Office' && selectedOfficeId ? [selectedOfficeId] : undefined
  );

  // Filter users based on search query
  const displayUsers = useMemo(() => {
    if (searchQuery.trim()) {
      return filteredUsers.filter(
        (user) =>
          user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.username.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return filteredUsers;
  }, [searchQuery, filteredUsers]);

  const handleFilterChange = (value: FilterType) => {
    setFilterBy(value);
    setSearchQuery(''); // Clear search when changing filter
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  const handleNPNForm = () => {
    dispatch(toggleBackoffice(true));
  };

  const handleForm = (state: boolean) => {
    dispatch(toggleForm(state));
  };

  return (
    <div style={{ width: '100%' }}>
      <div className='user-header'>
        <span className='user-tb-name'>Users</span>
        
      </div>

      <div className='filter-container'>
        <div className='filter'>
          <img src={Filter} alt='Filter' />
          <span>Filter By </span>
          <div className='a-p-tab-wrapper'>
            <Select
              value={filterBy}
              onChange={handleFilterChange}
              style={{ width: 150 }}>
              <Option value='Office'>Office</Option>
              <Option value='No Office'>No Office</Option>
            </Select>
            {filterBy === 'Office' && <OfficeNames />}
          </div>
        </div>

        <div style={{ width: '200px' }}>
          <Search
            placeholder='Search users...'
            enterButton='Search'
            onSearch={handleSearch}
            loading={filterLoading}
            style={{ marginLeft: 10 }}
          />
        </div>
      </div>

      <UsersTable users={displayUsers} loading={filterLoading} />

    
    </div>
  );
};

export default UsersTableContainer;
